'use client';

import type React from 'react';
import { useScrollContainer } from '@/app/_lib/providers/ScrollProvider';

interface ScrollableLayoutProps {
  children: React.ReactNode;
}

export const ScrollableLayout: React.FC<ScrollableLayoutProps> = ({ children }) => {
  const { scrollContainerRef } = useScrollContainer();

  return (
    <div
      ref={scrollContainerRef}
      className='fixed inset-0 scrollbar-thin scrollbar-track-[#00000000] scrollbar-thumb-primary/50 scrollbar-hover:scrollbar-thumb-primary scrollbar-thumb-rounded h-screen w-full overflow-y-auto'
    >
      {children}
    </div>
  );
};
